export default class MachineContractorState {

  static ALL = -1;
  static ACTIVE = 1;
  static INACTIVE = 2;

}



// WEBPACK FOOTER //
// ./src/app/shared/model/MachineContractorState.js